<template>
  <v-container>
    <NewSoftwareForm v-if="$route.params.formName === 'newSoftwareForm'" />
    <ModifySoftwareForm v-else-if="$route.params.formName === 'modifySoftwareForm'" />
  </v-container>
</template>

<script>
import ModifySoftwareForm from "./ModifySoftwareForm.vue";
import NewSoftwareForm from "./NewSoftwareForm.vue";

export default {
  name: "SoftwareForms",
  components: { ModifySoftwareForm, NewSoftwareForm }
};
</script>
